import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Root, Title, Content } from './styles';
import Icon from '../Icon';

class Collection extends PureComponent {
  render() {
    const { icon, content } = this.props;

    return (
      <Root className="collection">
        <Title>
          <Icon name={icon} />
        </Title>
        <Content>{content}</Content>
      </Root>
    );
  }
}

Collection.propTypes = {
  icon: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
};

export default Collection;
